export default function detectDeviceController() {
  const body = document.body;

  function detectDeviceType() {
    const width = window.innerWidth;

    // Clear previous classes
    body.classList.remove('device-desktop', 'device-tablet', 'device-mobile');

    if (width > 1024) {
      window.deviceType = 'desktop';
    } else if (width > 768) {
      window.deviceType = 'tablet';
    } else {
      window.deviceType = 'mobile';
    }

    body.classList.add('device-' + window.deviceType);
  }

  // Initial detection
  detectDeviceType();

  // Update classes on window resize
  window.addEventListener('resize', debounce(detectDeviceType, 250));
}
